import { Badge } from "@devhop/ui";
import { RiCalendarScheduleLine } from "@remixicon/react";
import { formatDbInBangkokLocale } from "@/shared/lib/date-time";

type Props = {
  preorderExpectedDate?: string | null;
  preorderEndAt?: string | null;
  showEndHint?: boolean;
};

export function PreorderBadge() {
  return (
    <Badge variant="secondary" className="gap-1 font-normal">
      <RiCalendarScheduleLine className="size-3" aria-hidden />
      ສັ່ງຈອງລ່ວງຫນ້າ
    </Badge>
  );
}

export function PreorderProductMeta({
  preorderExpectedDate,
  preorderEndAt,
  showEndHint = false,
}: Props) {
  const expectedLabel = preorderExpectedDate
    ? formatDbInBangkokLocale(preorderExpectedDate, "lo-LA", {
        dateStyle: "medium",
      })
    : null;
  const endLabel =
    showEndHint && preorderEndAt
      ? formatDbInBangkokLocale(preorderEndAt, "lo-LA", {
          dateStyle: "short",
          timeStyle: "short",
        })
      : null;

  return (
    <div className="mt-1 flex flex-col gap-0.5">
      <PreorderBadge />
      {expectedLabel ? (
        <p className="text-muted-foreground text-xs">
          ຄາດວ່າພ້ອມ: {expectedLabel}
        </p>
      ) : null}
      {endLabel ? (
        <p className="text-muted-foreground text-xs">ປິດຮັບ: {endLabel}</p>
      ) : null}
    </div>
  );
}
